import { IPatientIdentifier } from '../interfaces/patient.interface';
import { Coding } from '../../shared/interfaces/coding.interface';

export class PatientIdentifier implements IPatientIdentifier {
  assigner: { display: string; reference: string };
  period: { end: string; start: string };
  system: string;
  type: { coding: Coding[] };
  use: string;
  value: string;

  static CreateMRN(value: string, orgId?: string, orgName?: string): PatientIdentifier {
    return this.Clone(
      {
        use: 'usual',
        type: {
          coding: [
            {
              code: 'MRN',
              system: 'http://hl7.org/fhir/v2/0203',
              display: 'MRN'
            }
          ]
        },
        value: value,
        period: {
          end: '',
          start: ''
        },
        system: 'urn:oid:1.2.36.146.595.217.0.1',
        assigner: {
          display: orgName,
          reference: orgId
        }
      }
    );
  }

  static Clone(objectValue) {
    return Object.assign(new this(), objectValue);
  }
}
